/**
 * Flattens nested sections tree into a list of { id, name, path } for dropdown filters.
 * Only includes sections with supportsDashboard: true.
 */
export const flattenSectionsForFilter = (sections, path = '') => {
  const result = [];
  for (const s of sections || []) {
    const currentPath = path ? `${path} / ${s.name}` : s.name;
    if (s.supportsDashboard) {
      result.push({ id: s.id, name: s.name, path: currentPath });
    }
    if (s.children?.length) {
      result.push(...flattenSectionsForFilter(s.children, currentPath));
    }
  }
  return result;
};
